import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction } from '../models/api-model';
import { apiAction } from './base-api';

export const getReportAccess = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/organization_access`,
		onSuccess,
		onFailure,
	});
};



export const getArrearsReport = (id: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/organization_access/${id}/generate_report/arrears_report`,
		onSuccess,
		onFailure,
	});
};



export const getClergyReport = (id: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/organization_access/${id}/generate_report/clergy_compensation_report`,
		onSuccess,
		onFailure,
	});
};


export const getLayReport = (id: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/organization_access/${id}/generate_report/lay_compensation_report`,
		onSuccess,
		onFailure,
	});
};


export const getImputedIncomeReport = (id: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/organization_access/${id}/generate_report/imputed_income_report `,
		onSuccess,
		onFailure,
	});
};




export const pollReport = (url: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url,
		onSuccess,
		onFailure,
	});
};


export const downloadPolledReport = (id: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.reportPrc}/external_api/generate_reports/${id}`,
		onSuccess,
		onFailure,
	});
};